import {ChangeDetectorRef, Component, computed, Signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ModalComponent} from '../../../shared/modal/modal.component';
import {UserService} from '../../../shared/services/user.service';
import {DEFAULT_POINT_PACKS, IPointPack} from '../../../shared/constants/points.constants';

@Component({
  selector: 'app-points-list',
  templateUrl: 'point-list.component.html',
  styleUrls: ['point-list.component.scss'],
  imports: [CommonModule, FormsModule, ModalComponent]
})
export class PointsListComponent {
  customAmount: number = 0;
  isModalOpen = false;
  isPurchaseError = false;
  pointsEarned: string | number = 0;
  userBalance: Signal<number | undefined> = computed(() => this.userService.userProfile()?.balance);

  pointsPackages: IPointPack[] = DEFAULT_POINT_PACKS;

  constructor(private userService: UserService, private cdr: ChangeDetectorRef) {
  }

  validateInput() {
    if (!this.customAmount) return;

    const numValue = Number(this.customAmount);

    if (isNaN(numValue) || numValue < 0) {
      this.customAmount = 0;
    } else {
      this.customAmount = Math.floor(numValue);
    }
  }

  redirectToPayment(pack: IPointPack) {
    const pointsToBuy = pack.isCustom ? this.customAmount : pack.points;
    //тут должен быть редирект на оплату, если оплата успешна то одновляем баланс на беке и открываем модалку
    //обновить баланс юзера чтобы обновилось в хедере и тд, нам вернется обновленный юзер и тут его обновим но пока так
    const currentBalance = this.userService.userProfile()?.balance;
    this.userService.addPoints(Number(pointsToBuy)).subscribe({
      next: () => {
        console.log('Points updated successfully!');
        this.openModal(Number(pointsToBuy))
      },
      error: (err) => {
        this.isPurchaseError = true;
        this.cdr.detectChanges();
      }
    });
  }

  openModal(points: number) {
    console.log(points)
    this.pointsEarned = points;
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }
}
